import BookingEventModal from "./BookingEventModal";
import BookingAhiRefill from "./BookingAhiRefill";
import BookingAdditionalEquipment from "./BookingAdditionalEquipment";
import React, { Fragment, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  Button,
  Dropdown,
  Table,
  Pagination,
} from "react-bootstrap";

import { db, functions } from "../../../firebase";
import Toast from "../toast/SetToast";
import { httpsCallable } from "firebase/functions";
import {
  query,
  endAt,
  getDocs,
  getDoc,
  collection,
  orderBy,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  startAt,
  getCountFromServer,
  where,
  doc,
  collectionGroup,
} from "firebase/firestore";
import {
  notifyError,
  notifyTopRight,
  notifyWarning,
} from "../toast/SetToast";
import swal from "sweetalert";
import { useAuth } from "../../../context/AuthContext";
import { isPartTimeSleepTechnician } from "./BookingTechnicianPermissions";
import {
  filterBookingsForSaleAccess,
  isBookingSaleScopedUser,
} from "./BookingSaleAccess";
import {
  getPatientPagePath,
} from "./BookingEventUtils";
import {
  filterCustomersForStaffNode,
  filterRecordsByStaffCustomerAccess,
  hasExplicitStaffCustomerAccess,
  isStaffCustomerScopedUser,
} from "../../../utils/staffCustomerAccess";

import { getBookingReportChecklist, matchesBookingReportFilter } from "./BookingReportChecklistUtils";

import { createBookingLookupLoader, loadAccessibleBookingPage } from "./BookingLoadUtils";
import { BOOKING_EXPORT_CHUNK_SIZE, downloadBookingExport, loadBookingExportBookings } from "./BookingTableExport";

const BookingTable = ({
  text,
  sortBy,
  typeBy,
  statusBy,
  reportBy = "all",
  nodeBy,
  techBy,
  triggerRerender,
  onResetTriggerRerender,
}) => {
  const [latestDoc, setLatestDoc] = useState(null);
  const [firstDoc, setFirstDoc] = useState(null);
  const [prevFirstDoc, setPrevFirstDoc] = useState(null);
  const [prevLastestDoc, setPrevLastestDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(null);
  const exportBusyRef = useRef(false);
  const exportMountedRef = useRef(true);
  const [isCurrentUserPartTimeSleepTechnician, setIsPartTimeSleepTechnician] =
    useState(false);
  const [goNext, setGoNext] = useState(false);
  const [goPrev, setGoPrev] = useState(true);
  const [page, setPage] = useState(1);
  const [bookingsCount, setBookingsCount] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [docCount, setdocCount] = useState(0);

  const getSignedUrl = httpsCallable(functions, "getSignedUrl");
  const softDeleteBooking = httpsCallable(functions, "softDeleteBooking");

  const { currentUser } = useAuth();
  const itemsPerPage = 33;
  const staffAccessContextRef = useRef({
    adminData: null,
    nodes: [],
  });
  const restrictedBookingDocsRef = useRef([]);
  const bookingRequestIdRef = useRef(0);
  const ahiRefillBusyRef = useRef(false);
  const lookupLoaderRef = useRef(null);
  if (!lookupLoaderRef.current) lookupLoaderRef.current = createBookingLookupLoader();
  const lookupUserKey = JSON.stringify([
    currentUser && currentUser.uid,
    currentUser && currentUser.displayName,
    (currentUser && currentUser.roles) || [],
  ]);
  const activeLookupUserKeyRef = useRef(lookupUserKey);
  activeLookupUserKeyRef.current = lookupUserKey;
  const exportScopeKey = JSON.stringify([lookupUserKey, text, sortBy, typeBy, statusBy, reportBy, nodeBy, techBy]);
  const activeExportScopeRef = useRef(exportScopeKey);
  activeExportScopeRef.current = exportScopeKey;
  useEffect(() => () => { exportMountedRef.current = false; }, []);
  const canDeleteBookings =
    currentUser &&
    Array.isArray(currentUser.roles) &&
    currentUser.roles.some((role) =>
      ["super_admin", "admin"].includes(role),
    );
  // console.log("text:", text);
  // console.log("sortBy:", sortBy);
  // console.log("typeBy:", typeBy);

  const refDeleteDoc = async (bookingInfo) => {
    if (!canDeleteBookings) {
      notifyError("Only super_admin and admin can delete a booking.");
      return false;
    }

    const bookingProps = (bookingInfo && bookingInfo.extendedProps) || {};
    const bookingId = bookingProps.uuid;
    const nodeIndex = nodeList.indexOf(bookingProps.node);
    const nodeId = nodeIdDocs[nodeIndex];
    if (!bookingId || !nodeId) {
      notifyError(
        "Cannot delete this booking because its exact calendar record was not found.",
      );
      return false;
    }

    try {
      const response = await softDeleteBooking({ nodeId, bookingId });
      await initNewData();
      notifyTopRight(
        `Booking moved to Recovery${
          response.data && response.data.recoveryId
            ? ` (${response.data.recoveryId})`
            : ""
        }`,
      );
      return true;
    } catch (error) {
      console.error("Unable to move booking to recovery", error);
      notifyError(
        `Delete booking failed: ${(error && error.message) || error}`,
      );
      return false;
    }
  };

  const confirmDeleteBooking = async (bookingInfo) => {
    if (!canDeleteBookings) {
      notifyError("Only super_admin and admin can delete a booking.");
      return false;
    }

    const bookingProps = (bookingInfo && bookingInfo.extendedProps) || {};
    const label =
      bookingProps.order || (bookingInfo && bookingInfo.title) || "this booking";
    const willDelete = await swal({
      title: `Move ${label} to Booking Recovery?`,
      text:
        "It will leave the normal calendar, but its complete record and the deleting user will be kept in Booking Recovery. Only the configured admin888 account can permanently delete it.",
      icon: "warning",
      buttons: ["Cancel", "Move to Recovery"],
      dangerMode: true,
    });

    if (!willDelete) return false;
    return refDeleteDoc(bookingInfo);
  };

  // // SET DEFAULT
  let bookingsCollectionGroupRef = collectionGroup(db, "bookings");

  // let queryHandler = query(
  //   collection(db, "nodes"),
  //   orderBy(sortBy),
  //   limit(itemsPerPage)
  // );
  let queryHandler = query(
    bookingsCollectionGroupRef,
    orderBy(sortBy),
    // where(attributeName, '==', attributeValue),
    limit(itemsPerPage),
  );

  let count;

  const hasRestrictedBookingAccess = () =>
    (isStaffCustomerScopedUser(currentUser) &&
      hasExplicitStaffCustomerAccess(
        staffAccessContextRef.current.adminData,
      )) ||
    isBookingSaleScopedUser(currentUser);

  const loadBookingDocs = async (bookingDocs) =>
    Promise.all(
      bookingDocs.map(async (booking) => {
        const bookingData = {
          ...(typeof booking.data === "function" ? booking.data() : booking),
        };
        const dateStart = new Date(bookingData.start.toDate());
        dateStart.setHours(dateStart.getHours() + 7);
        bookingData.start = dateStart.toISOString().slice(0, 10);

        const hn = String((bookingData.extendedProps || {}).hn || "").trim();
        if (!hn) {
          bookingData.reports = [];
          return bookingData;
        }

        const patientReports = await getDocs(
          collection(db, "patients", hn, "report"),
        );
        bookingData.reports = patientReports.docs.map((report) => ({
          ...report.data(),
          id: report.id,
        }));
        return bookingData;
      }),
    );

  const filterRestrictedBookingDocs = (bookingDocs) => {
    const accessContext = staffAccessContextRef.current;
    let restrictedBookingDocs = bookingDocs;

    if (
      isStaffCustomerScopedUser(currentUser) &&
      hasExplicitStaffCustomerAccess(accessContext.adminData)
    ) {
      restrictedBookingDocs = restrictedBookingDocs.filter(
        (bookingDoc) =>
          filterRecordsByStaffCustomerAccess({
            records: [bookingDoc.data()],
            currentUser,
            adminData: accessContext.adminData,
            nodes: accessContext.nodes,
            getNodeValue: (booking) =>
              booking.extendedProps && booking.extendedProps.node,
            getCustomerValue: (booking) =>
              booking.extendedProps && booking.extendedProps.customer,
          }).length > 0,
      );
    }

    let matchingBookingDocs = filterBookingsForSaleAccess({
      records: restrictedBookingDocs,
      currentUser,
      assignedNodes: accessContext.nodes,
      getNodeValue: (bookingDoc) => {
        const booking = bookingDoc.data();
        return booking.extendedProps && booking.extendedProps.node;
      },
      getSaleValue: (bookingDoc) => {
        const booking = bookingDoc.data();
        return booking.extendedProps && booking.extendedProps.sale;
      },
    });
    return matchingBookingDocs;
  };

  const setRestrictedBookingPage = async (nextPageNumber) => {
    const requestId = bookingRequestIdRef.current;
    const pages = restrictedBookingDocsRef.current;
    let nextPageData = pages[nextPageNumber - 1];
    if (!nextPageData) {
      nextPageData = await loadAccessibleBookingPage({
        previousPage: pages[nextPageNumber - 2],
        pageSize: itemsPerPage,
        isCurrent: () => requestId === bookingRequestIdRef.current,
        filterDocs: filterRestrictedBookingDocs,
        fetchChunk: async (lastDoc) => {
          const constraints = [];
          if (lastDoc) constraints.push(startAfter(lastDoc));
          constraints.push(limit(itemsPerPage));
          const pageQuery = query(buildQuery(
            collectionGroup(db, "bookings"), sortBy, statusBy, typeBy,
            nodeBy, techBy, currentUser, text, undefined, "All",
          ), ...constraints);
          const snapshot = await getDocs(pageQuery);
          return snapshot.docs;
        },
      });
      if (!nextPageData || requestId !== bookingRequestIdRef.current) return;
      pages[nextPageNumber - 1] = nextPageData;
    }
    const pageBookings = await loadBookingDocs(nextPageData.docs);
    if (requestId !== bookingRequestIdRef.current) return;
    setBookingList(pageBookings);
    setPage(nextPageNumber);
    setGoPrev(nextPageNumber > 1);
    setGoNext(nextPageData.hasNext);
    setTotalPages(0);
  };

  // //  NEXT PAGE
  const nextPage = async () => {
    setLoading(true);
    if (hasRestrictedBookingAccess()) {
      await setRestrictedBookingPage(page + 1);
      setLoading(false);
      return;
    }
    let bookingsCollectionGroupRef = collectionGroup(db, "bookings");
    var statusPage = "Next";
    // Pass your parameters here, including dates if searchTime is true
    let queryHandler = buildQuery(
      bookingsCollectionGroupRef,
      sortBy,
      statusBy,
      typeBy,
      nodeBy,
      techBy,
      currentUser,
      text,
      itemsPerPage,
      statusPage,
    );
    // const tempBooking = [];
    // const docSnap = await getDocs(queryHandler);
    // // count = docSnap.size;
    // if (docSnap.empty) {
    //   console.log("No documents found");
    // } else {
    //   docSnap.forEach((booking) => {
    //     const bookingData = booking.data();
    //     const dateStart = new Date(bookingData.start.toDate());
    //     dateStart.setHours(dateStart.getHours() + 7);
    //     bookingData.start = dateStart.toISOString().slice(0, 10);

    //     tempBooking.push({ ...bookingData });
    //   });
    // }
    const tempBooking = [];
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
    } else {
      const promises = docSnap.docs.map(async (booking) => {
        const bookingData = booking.data();
        const dateStart = new Date(bookingData.start.toDate());
        dateStart.setHours(dateStart.getHours() + 7);
        bookingData.start = dateStart.toISOString().slice(0, 10);

        if (
          bookingData.extendedProps.hn == "" ||
          !bookingData.extendedProps.hn
        ) {
          bookingData.reports = [];
        } else {
          // add booking reports
          const patientReports = await getDocs(
            collection(db, "patients", bookingData.extendedProps.hn, "report"),
          );
          if (patientReports.empty) {
            bookingData.reports = [];
          } else {
            const reports = [];
            patientReports.forEach((report) => {
              var reportData = report.data();
              var id = report.id;
              reportData = { ...reportData, id };
              reports.push(reportData);
              // console.log("report: ",report.data())
            });
            bookingData.reports = reports;
          }
        }
        tempBooking.push({ ...bookingData });
      });

      // Wait for all promises to resolve
      await Promise.all(promises);
    }

    if (page + 1 >= totalPages) {
      setGoNext(false);
    }
    setLoading(false);
    setPage(page + 1);
    setBookingList(tempBooking);
    setLatestDoc(docSnap.docs[docSnap.docs.length - 1]);
    setFirstDoc(docSnap.docs[0]);
    setGoPrev(true);
  };

  // //  PREV PAGE
  const previousPage = async () => {
    setLoading(true);
    if (hasRestrictedBookingAccess()) {
      await setRestrictedBookingPage(page - 1);
      setLoading(false);
      return;
    }
    let bookingsCollectionGroupRef = collectionGroup(db, "bookings");
    var statusPage = "Prev";
    // Pass your parameters here, including dates if searchTime is true
    let queryHandler = buildQuery(
      bookingsCollectionGroupRef,
      sortBy,
      statusBy,
      typeBy,
      nodeBy,
      techBy,
      currentUser,
      text,
      itemsPerPage,
      statusPage,
    );

    // const tempBooking = [];
    // const docSnap = await getDocs(queryHandler);
    // // count = docSnap.size;
    // if (docSnap.empty) {
    //   console.log("No documents found");
    // } else {
    //   docSnap.forEach((booking) => {
    //     const bookingData = booking.data();
    //     const dateStart = new Date(bookingData.start.toDate());
    //     dateStart.setHours(dateStart.getHours() + 7);
    //     bookingData.start = dateStart.toISOString().slice(0, 10);
    //     tempBooking.push({ ...bookingData });
    //   });
    // }

    const tempBooking = [];
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
    } else {
      const promises = docSnap.docs.map(async (booking) => {
        const bookingData = booking.data();
        const dateStart = new Date(bookingData.start.toDate());
        dateStart.setHours(dateStart.getHours() + 7);
        bookingData.start = dateStart.toISOString().slice(0, 10);

        if (
          bookingData.extendedProps.hn == "" ||
          !bookingData.extendedProps.hn
        ) {
          bookingData.reports = [];
        } else {
          // add booking reports
          const patientReports = await getDocs(
            collection(db, "patients", bookingData.extendedProps.hn, "report"),
          );
          if (patientReports.empty) {
            bookingData.reports = [];
          } else {
            const reports = [];
            patientReports.forEach((report) => {
              var reportData = report.data();
              var id = report.id;
              reportData = { ...reportData, id };
              reports.push(reportData);
              // console.log("report: ",report.data())
            });
            bookingData.reports = reports;
          }
        }
        tempBooking.push({ ...bookingData });
      });

      // Wait for all promises to resolve
      await Promise.all(promises);
    }

    setLoading(false);
    setPage(page - 1);
    if (page <= 2) {
      setGoPrev(false);
    }
    setBookingList(tempBooking);
    setLatestDoc(docSnap.docs[docSnap.docs.length - 1]);
    setFirstDoc(docSnap.docs[0]);
    setGoNext(true);
  };

  // const typeList = typeList;
  // const statusList = statusList;
  // const colorList = colorList;
  // const orderList = orderList;
  // const paymentPrivilages = paymentPrivilages;

  const drop = (bookingInfo) => {
    return (
      <Dropdown>
        <Dropdown.Toggle variant="" className="table-dropdown icon-false">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <rect x="0" y="0" width="24" height="24"></rect>
              <circle fill="#000000" cx="5" cy="12" r="2"></circle>
              <circle fill="#000000" cx="12" cy="12" r="2"></circle>
              <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => {
              handleBookingClick(bookingInfo);
            }}
          >
            Order Detail
          </Dropdown.Item>
          <Dropdown.Item
            href={getPatientPagePath(bookingInfo.extendedProps.hn)}
          >
            Patient Page
          </Dropdown.Item>
          {canDeleteBookings && (
            <Dropdown.Item
              href="#"
              onClick={async (event) => {
                if (event && event.preventDefault) event.preventDefault();
                await confirmDeleteBooking(bookingInfo);
              }}
              className="text-danger"
            >
              Move to Recovery
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  };
  const [bookingList, setBookingList] = useState([]);
  const [nodeList, setNodeList] = useState([]);
  const [nodeIdDocs, setNodeIdDocs] = useState([]);
  const [customerAllList, setCustomerAllList] = useState([]);
  const [currentBooking, setCurrentBooking] = useState(null);
  const [editEventModal, setEditEventModal] = useState(false);
  const [technicianList, setTechnicianList] = useState([]);
  const [techrecordList, setTechRecordList] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const handleBookingClick = (bookingInfo) => {
    if (ahiRefillBusyRef.current) {
      notifyWarning("Wait for AHI refill to finish before editing a booking.");
      return;
    }
    setCurrentBooking(bookingInfo);
    setEditEventModal(true);
  };

  const handleCloseModal = () => {
    setEditEventModal(false);
    setCurrentBooking(null);
  };

  const handleReportsChange = (hn, reports) => {
    setBookingList((bookings) => bookings.map((booking) =>
      String((booking.extendedProps || {}).hn || "").trim() === hn
        ? { ...booking, reports }
        : booking,
    ));
  };

  const refreshBookingTable = async () => {
    try {
      await initNewData();
    } catch (error) {
      console.error("Unable to refresh booking table", error);
      notifyError("Unable to refresh bookings. Please try again.");
    }
  };

  const buildQuery = (
    collectionRef,
    sortBy,
    statusBy,
    typeBy,
    nodeBy,
    techBy,
    currentUser,
    text,
    itemsPerPage,
    statusPage,
  ) => {
    let queryConstraints = [];

    queryConstraints.push(
      orderBy(sortBy === "start" ? "start" : `extendedProps.${sortBy}`),
    );

    if (statusBy !== "ทั้งหมด") {
      queryConstraints.push(where("extendedProps.status", "==", statusBy));
    }

    if (typeBy !== "ทั้งหมด") {
      queryConstraints.push(where("extendedProps.type", "==", typeBy));
    }

    if (nodeBy !== "ทั้งหมด") {
      queryConstraints.push(where("extendedProps.node", "==", nodeBy));
    }

    if ((currentUser.roles || []).includes("sleep_physician")) {
      queryConstraints.push(
        where("extendedProps.doctor", "==", currentUser.displayName),
      );
    }

    if ((currentUser.roles || []).includes("sleep_technician")) {
      queryConstraints.push(
        where("extendedProps.techrecord", "==", currentUser.displayName),
      );
    }

    if (
      (currentUser.roles || []).includes("super_admin") &&
      !["กรุณาเลือก", ""].includes(techBy)
    ) {
      queryConstraints.push(where("extendedProps.techrecord", "==", techBy));
    }

    if (sortBy !== "start" && text) {
      queryConstraints.push(where(`extendedProps.${sortBy}`, ">=", text));
      queryConstraints.push(
        where(`extendedProps.${sortBy}`, "<=", text + "\uf8ff"),
      );
    }
    if (statusPage == "Init") {
      queryConstraints.push(startAfter(null));
      queryConstraints.push(limit(itemsPerPage));
    } else if (statusPage == "Next") {
      queryConstraints.push(startAfter(latestDoc));
      queryConstraints.push(limit(itemsPerPage));
    } else if (statusPage == "Prev") {
      queryConstraints.push(endBefore(firstDoc));
      queryConstraints.push(limitToLast(itemsPerPage));
    }
    // Always apply pagination last

    return query(collectionRef, ...queryConstraints);
  };

  const initNewData = async () => {
    const requestId = ++bookingRequestIdRef.current;
    // Usage of the buildQuery function
    let bookingsCollectionGroupRef = collectionGroup(db, "bookings");
    var statusPage = "Init";
    // Pass your parameters here, including dates if searchTime is true
    let queryHandler = buildQuery(
      bookingsCollectionGroupRef,
      sortBy,
      statusBy,
      typeBy,
      nodeBy,
      techBy,
      currentUser,
      text,
      itemsPerPage,
      statusPage,
    );

    if (hasRestrictedBookingAccess()) {
      restrictedBookingDocsRef.current = [];
      await setRestrictedBookingPage(1);
      return;
    }

    // Counting documents may require a separate function without limit constraint
    var count = await getCountFromServer(
      buildQuery(
        bookingsCollectionGroupRef,
        sortBy,
        statusBy,
        typeBy,
        nodeBy,
        techBy,
        currentUser,
        text,
        undefined, // No limit for the count
        "Count",
      ),
    );
    // const tempBooking = [];
    // const docSnap = await getDocs(queryHandler);
    // if (docSnap.empty) {
    //   console.log("No documents found");
    // } else {
    //   docSnap.forEach(async (booking) => {
    //     const bookingData = booking.data();
    //     const dateStart = new Date(bookingData.start.toDate());
    //     dateStart.setHours(dateStart.getHours() + 7);
    //     bookingData.start = dateStart.toISOString().slice(0, 10);

    //     // add booking reports
    //     const patientReports = await getDocs(collection(db,"patients",bookingData.extendedProps.hn,"report"))
    //     if (patientReports.empty) {
    //       bookingData.reports = []
    //     } else {
    //       const reports = []
    //       patientReports.forEach((report) => {
    //         reports.push(report.data())
    //       })
    //       bookingData.reports = reports
    //     }
    //     tempBooking.push({ ...bookingData });
    //   });
    // }

    const tempBooking = [];
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
    } else {
      const promises = docSnap.docs.map(async (booking) => {
        const bookingData = booking.data();
        const dateStart = new Date(bookingData.start.toDate());
        dateStart.setHours(dateStart.getHours() + 7);
        bookingData.start = dateStart.toISOString().slice(0, 10);

        // add booking reports
        if (
          bookingData.extendedProps.hn == "" ||
          !bookingData.extendedProps.hn
        ) {
          bookingData.reports = [];
        } else {
          const patientReports = await getDocs(
            collection(db, "patients", bookingData.extendedProps.hn, "report"),
          );
          if (patientReports.empty) {
            bookingData.reports = [];
          } else {
            const reports = [];
            patientReports.forEach((report) => {
              var reportData = report.data();
              var id = report.id;
              reportData = { ...reportData, id };
              reports.push(reportData);
              // console.log("report: ",report.data())
            });
            bookingData.reports = reports;
          }
        }
        tempBooking.push({ ...bookingData });
      });

      // Wait for all promises to resolve
      await Promise.all(promises);
    }

    // Ignore a result if the filters changed while reports were loading.
    if (requestId !== bookingRequestIdRef.current) return;
    // Now tempBooking is updated, you can set it to bookingList
    setBookingList(tempBooking);

    // setBookingList(tempBooking);
    var totalPagesTmp = Math.ceil(count.data().count / itemsPerPage);
    setBookingsCount(count.data().count);
    setTotalPages(totalPagesTmp);
    setPage(1);
    // setPage(1);

    if (docSnap.docs.length >= 1) {
      setLatestDoc(docSnap.docs[docSnap.docs.length - 1]);
      setFirstDoc(docSnap.docs[0]);
    } else {
      setLatestDoc(null);
      setFirstDoc(null);
    }

    // You can do whatever you want with the tempBooking array here
    if (count.data().count <= itemsPerPage) {
      console.log("no more doc");
      setGoNext(false);
      setGoPrev(false);
    } else {
      setGoNext(true);
      setGoPrev(false);
    }
    // setLoading(false);
  };

  const fetchAnotherData = async () => {
    try {
      // Use Promise.all for parallel fetching
      const [nodesDocs, itemsDocs, techDocs, docDocs, salesDocs] =
        await Promise.all([
        getDocs(collection(db, "nodes")),
        getDocs(collection(db, "items")),
        getDocs(collection(db, "sleeptechnicians")),
        getDocs(collection(db, "doctors")),
        getDocs(collection(db, "sales")),
        // getDocs(collectionGroup(db,"customers"))
        ]);

      let allCustomers = [];
      let allnodeIdDocs = [];
      let allItems = [];
      let allNodes;
      let allowedNodeDocs = nodesDocs.docs.map((nodeDoc) => ({
        id: nodeDoc.id,
        ...nodeDoc.data(),
      }));
      let currentAdminData = null;
      const technicianProfiles = techDocs.docs.map((techDoc) =>
        techDoc.data(),
      );
      const currentUserIsPartTimeSleepTechnician =
        isPartTimeSleepTechnician(currentUser, technicianProfiles);
      const currentUserRoles = Array.isArray(currentUser.roles)
        ? currentUser.roles
        : [];
      if (
        !isBookingSaleScopedUser(currentUser) &&
        (currentUserRoles.includes("super_admin") ||
          currentUserRoles.includes("accountant") ||
          currentUserIsPartTimeSleepTechnician)
      ) {
        allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        for (const nodeDoc of nodesDocs.docs) {
          allnodeIdDocs = [...allnodeIdDocs, nodeDoc.id];
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeDoc.id, "customers"),
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
        allItems = itemsDocs.docs.map((doc) => ({
          ...doc.data(),
          itemcode: doc.id,
        }));
      } else if (
        !isBookingSaleScopedUser(currentUser) &&
        currentUserRoles.includes("sleep_physician")
      ) {
        allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        for (const nodeDoc of nodesDocs.docs) {
          allnodeIdDocs = [...allnodeIdDocs, nodeDoc.id];
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeDoc.id, "customers"),
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
        allItems = itemsDocs.docs.map((doc) => ({
          ...doc.data(),
          itemcode: doc.id,
        }));
      } else {
        // allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        const currentAdmin = await getDoc(
          doc(db, "admins", currentUser.displayName),
        );
        currentAdminData = currentAdmin.exists() ? currentAdmin.data() : {};
        let nodeCode = currentAdminData.node || [];
        if (!Array.isArray(nodeCode)) {
          nodeCode = nodeCode ? [nodeCode] : [];
        }
        allowedNodeDocs = allowedNodeDocs.filter((nodeData) =>
          nodeCode.includes(nodeData.nodecode),
        );
        allnodeIdDocs = allowedNodeDocs.map((nodeData) => nodeData.id);
        allNodes = allowedNodeDocs.map((nodeData) => nodeData.nodename);

        for (const nodeData of allowedNodeDocs) {
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeData.id, "customers"),
          );
          const allowedCustomers = filterCustomersForStaffNode({
            customers: customerDocs.docs,
            currentUser,
            adminData: currentAdminData,
            nodeCode: nodeData.nodecode,
            getCustomerId: (customerDoc) => customerDoc.id,
          });
          const customersData = allowedCustomers.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
        allItems = itemsDocs.docs
          .map((doc) => ({
            ...doc.data(),
            itemcode: doc.id,
          }))
          .filter((doc) => {
            return nodeCode.includes(doc.node);
          });
      }

      if (activeLookupUserKeyRef.current !== lookupUserKey) return;
      staffAccessContextRef.current = {
        adminData: currentAdminData,
        nodes: allowedNodeDocs,
      };

      const allTechs = [
        { name: "กรุณาเลือก", nickname: "กรุณาเลือก" },
        ...techDocs.docs.map((techDoc) => ({
          name: techDoc.data().name || "",
          nickname: techDoc.data().nickname || "",
        })),
      ];
      const allDocs = [
        "กรุณาเลือก",
        ...docDocs.docs.map((doc) => doc.data().name),
      ];
      const allSales = salesDocs.docs
        .map((saleDoc) => saleDoc.data().name || "")
        .filter(Boolean)
        .sort((left, right) => left.localeCompare(right, "en"));
      setIsPartTimeSleepTechnician(
        currentUserIsPartTimeSleepTechnician,
      );
      setCustomerAllList(allCustomers);
      setNodeList(allNodes);
      setNodeIdDocs(allnodeIdDocs);
      setDoctorList(allDocs);
      setSaleList(allSales);
      setTechnicianList(allTechs);
      setTechRecordList(allTechs);
      setItemList(allItems);
    } catch (error) {
      console.log("Error fetching data: ", error);
      throw error;
    }
  };

  // useEffect(() => {
  //   setLoading(true);
  //   // Call the fetchData function to get the tempBooking array
  //   fetchAnotherData();
  //   // fetchData();
  //   initNewData();
  //   if (triggerRerender) {
  //     onResetTriggerRerender();
  //   }
  // }, [
  //   text,
  //   sortBy,
  //   typeBy,
  //   statusBy,
  //   nodeBy,
  //   bookingsCount,
  //   triggerRerender,
  //   onResetTriggerRerender,
  // ]);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    const fetchData = async () => {
      try {
        // Fetch additional data
        await lookupLoaderRef.current(lookupUserKey, fetchAnotherData);
        if (cancelled) return;

        // Fetch booking data
        await initNewData();
        if (cancelled) return;

        // Reset the trigger if used for re-rendering
        if (triggerRerender) {
          onResetTriggerRerender();
        }

        setLoading(false); // Set loading to false once all data is fetched
      } catch (error) {
        console.log("Error fetching data: ", error);
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
      bookingRequestIdRef.current += 1;
    };
  }, [
    text,
    sortBy,
    typeBy,
    statusBy,
    nodeBy,
    techBy,
    lookupUserKey,
    triggerRerender, // Removed bookingsCount to prevent unnecessary re-renders
  ]);

  const handleOnDownload = async (reports) => {
    if (!Array.isArray(reports) || reports.length === 0) return;

    for (const report of reports) {
      const files = Array.isArray(report.reportFile)
        ? report.reportFile
        : report.reportFile
          ? [report.reportFile]
          : [];

      for (const file of files) {
        try {
          const result = await getSignedUrl({
            folder: "reports",
            hn: report.hn,
            id: report.id,
            filename: file,
          });
          const response = await fetch(result.data);

          if (!response.ok) {
            throw new Error(
              `Report download failed with status ${response.status}`,
            );
          }

          const blob = await response.blob();
          const fileURL = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = fileURL;
          downloadLink.download = file;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          downloadLink.remove();
          window.URL.revokeObjectURL(fileURL);
        } catch (error) {
          console.error("Unable to download booking report file", error);
          notifyError("Cannot download report file. Please try again.");
        }
      }
    }
  };

  const handleExport = async () => {
    if (loading || exportBusyRef.current) return;
    exportBusyRef.current = true;
    setExporting(true);
    setExportProgress({ scanned: 0, matched: 0 });
    const isCurrent = () => exportMountedRef.current && activeExportScopeRef.current === exportScopeKey;
    try {
      await lookupLoaderRef.current(lookupUserKey, fetchAnotherData);
      if (!isCurrent()) return;
      // Reuse every table query constraint, starting from the first matching row.
      const exportQuery = buildQuery(
        collectionGroup(db, "bookings"), sortBy, statusBy, typeBy,
        nodeBy, techBy, currentUser, text, undefined, "All",
      );
      const bookings = await loadBookingExportBookings({
        fetchChunk: async (cursor) => {
          const constraints = [limit(BOOKING_EXPORT_CHUNK_SIZE)];
          if (cursor) constraints.push(startAfter(cursor));
          const snapshot = await getDocs(query(exportQuery, ...constraints));
          return snapshot.docs;
        },
        filterDocs: filterRestrictedBookingDocs,
        loadReports: async (hn) => {
          const snapshot = await getDocs(collection(db, "patients", hn, "report"));
          return snapshot.docs.map((report) => ({ ...report.data(), id: report.id }));
        },
        reportBy,
        isCurrent,
        onProgress: setExportProgress,
      });
      if (!isCurrent()) return;
      if (!bookings.length) {
        notifyWarning("No bookings match the current filters.");
        return;
      }
      await downloadBookingExport(bookings, isCurrent);
      notifyTopRight(`Exported ${bookings.length} bookings from all matching pages.`);
    } catch (error) {
      console.error("Unable to export bookings", error);
      if (exportMountedRef.current) notifyError(`Booking export failed: ${error.message || error}`);
    } finally {
      exportBusyRef.current = false;
      if (exportMountedRef.current) {
        setExporting(false);
        setExportProgress(null);
      }
    }
  };

  const visibleBookings = bookingList.filter((booking) =>
    matchesBookingReportFilter(
      getBookingReportChecklist(booking.reports || [], booking.extendedProps || {}),
      reportBy,
    ),
  );

  return (
    <Fragment>
      <Toast />
      <BookingAhiRefill
        currentUser={currentUser}
        disabled={loading || editEventModal}
        onBusyChange={(busy) => { ahiRefillBusyRef.current = busy; }}
        nodes={staffAccessContextRef.current.nodes}
        filterAccessibleDocs={filterRestrictedBookingDocs}
        onSaved={(item, ahi, saved) => {
          const original = item.data.extendedProps || {};
          const audit = saved.status === "updated"
            ? { updatedBy: saved.updatedBy, updatedAt: saved.updatedAt } : {};
          const update = (booking) => {
            const props = (booking && booking.extendedProps) || {};
            return props.uuid === item.ref.id && props.node === original.node && props.hn === original.hn
              ? { ...booking, extendedProps: { ...props, ahi, ...audit } } : booking;
          };
          setBookingList((bookings) => bookings.map(update));
          setCurrentBooking(update);
        }}
      />
      <div className="d-flex flex-wrap justify-content-end align-items-center mb-3">
        {exportProgress && (
          <span className="small text-muted mr-3" role="status">
            {exportProgress.scanned} checked · {exportProgress.matched} matching bookings
          </span>
        )}
        <Button variant="outline-success" size="sm" disabled={loading || exporting} onClick={handleExport}
          title="Export all bookings matching the current filters, across every page.">
          <i className="fa fa-file-excel-o mr-2" aria-hidden="true" />
          {exporting ? "Exporting…" : "Export Excel (all filtered pages)"}
        </Button>
      </div>
      {!loading ? (
        <>
          {" "}
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body className="card-body">
                  {hasRestrictedBookingAccess() && (
                    <div className="small text-muted mb-2">
                      Showing cases you can access.
                    </div>
                  )}
                  {reportBy !== "all" && (
                    <div className="small text-muted mb-2" role="status">
                      Report filter: {visibleBookings.length} of {bookingList.length} cases on this page.
                      {" "}Use Next / Previous to check other pages.
                    </div>
                  )}
                  <Table className="table-responsive-12 mb-0 table-striped">
                    <thead>
                      <tr>
                        <th> </th>
                        <th>Node</th>
                        <th>Sleep Study</th>
                        <th>Name</th>
                        <th>HN</th>
                        <th>TYPE</th>
                        <th>STATUS</th>
                        <th>REPORT</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody id="booking-table">
                      {hasRestrictedBookingAccess() && reportBy === "all" && bookingList.length === 0 && (
                        <tr><td colSpan={9} className="text-center">No accessible cases on this page. Use Next if available.</td></tr>
                      )}
                      {reportBy !== "all" && visibleBookings.length === 0 && (
                        <tr><td colSpan={9} className="text-center">No matching reports on this page.</td></tr>
                      )}
                      {visibleBookings.map((element, index) => {
                        return (
                          <tr>
                            <td className="py-0">
                              {index + 1 + 33 * (page - 1)}
                            </td>
                            <td className="py-0">
                              {element.extendedProps.node}
                            </td>
                            <td className="py-0">
                              <Link
                                onClick={() => {
                                  handleBookingClick(element);
                                }}
                                to="#"
                              >
                                {element.extendedProps.order}
                              </Link>
                            </td>
                            <td className="py-0">
                              <Link
                                // target="_blank"
                                to={getPatientPagePath(
                                  element.extendedProps.hn,
                                )}
                              >
                                {" "}
                                {element.extendedProps.firstname +
                                  " " +
                                  element.extendedProps.lastname}
                              </Link>
                            </td>
                            <td className="py-0">
                              <Link
                                // target="_blank"
                                to={getPatientPagePath(
                                  element.extendedProps.hn,
                                )}
                              >
                                {element.extendedProps.hn}
                              </Link>
                            </td>
                            <td className="py-0">
                              {element.extendedProps.type}
                              <BookingAdditionalEquipment
                                value={element.extendedProps.additionalEquipment}
                                compact
                              />
                            </td>
                            <td className="py-0">
                              {element.extendedProps.status +
                                " (" +
                                element.start +
                                ")"}
                            </td>
                            <td>
                              {" "}
                              <Link
                                to="#"
                                className={
                                  element.reports && element.reports.length > 0
                                    ? "btn btn-info shadow btn-xs sharp mr-1"
                                    : "btn btn-dark shadow btn-xs sharp mr-1"
                                }
                                onClick={() => {
                                  handleOnDownload(element.reports);
                                }}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Download item"
                              >
                                {/* {element.extendedProps.reports && element.extendedProps.reports.length > 0 ? (<i className="fa fa-download"></i>) : (<i className="fa fa-download" style={{color: "red"}}></i>)}  */}
                                <i className="fa fa-download"></i>
                                {/* {element.extendedProps.reports.length} */}
                              </Link>
                            </td>

                            <td className="py-0">{drop(element)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>

                  <div className="d-flex justify-content-center mt-3">
                    <Pagination
                      className="pagination-primary pagination-circle"
                      size="lg"
                    >
                      <Button
                        onClick={previousPage}
                        disabled={!goPrev}
                        className="page-link"
                      >
                        <i className="la la-angle-left" />
                      </Button>
                      {/* {Page }{totalPages} */}
                      <div className="d-flex justify-content-center mr-5 ml-5 mt-2">
                        {hasRestrictedBookingAccess() ? `Page ${page}` : `${page} / ${totalPages}`}
                      </div>

                      <Button
                        onClick={nextPage}
                        disabled={!goNext}
                        className="page-link"
                      >
                        <i className="la la-angle-right" />
                      </Button>
                    </Pagination>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {currentBooking && editEventModal && (
            <BookingEventModal
              key={lookupUserKey}
              booking={currentBooking}
              bookingEvents={bookingList}
              lookupData={{
                nodeList,
                nodeIdDocs,
                customerAllList,
                technicianList,
                techrecordList,
                doctorList,
                saleList,
                itemList,
                allowedNodeDocs: staffAccessContextRef.current.nodes,
                staffAdminProfile: staffAccessContextRef.current.adminData,
                isPartTimeSleepTechnician: isCurrentUserPartTimeSleepTechnician,
              }}
              onClose={handleCloseModal}
              onSaved={refreshBookingTable}
              onRemoved={refreshBookingTable}
              onReportsChange={handleReportsChange}
            />
          )}
        </>
      ) : (
        <div class="media d-flex align-items-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden"></span>
          </div>
        </div>
      )}
    </Fragment>
  );
};

//   const handleDate = (date) => {
//     if (date != undefined) {
//       try {
//         var datetime = new Date(
//           date.toDate().setHours(new Date(date.toDate()).getHours() + 7)
//         )
//           .toISOString()
//           .replace("T", " ")
//           .slice(0, 19);
//         return datetime;
//       } catch {
//         // console.log(new Date(date).getHours());
//         // console.log(date);
//         var newDate = new Date(date);
//         var hours = newDate.getHours() + 7;
//         newDate = new Date(newDate.setHours(hours));
//         var newString = newDate.toISOString().replace("T", " ").slice(0, 19);

//         return newString;
//       }
//     } else {
//       return "";
//     }
//   };

export default BookingTable;
